import { LayoutBackButton as SharedLayoutBackButton } from "../../../../../../shared/frontend/settings/LayoutBackButton";
import { useI18n } from "../i18n/useI18n";
import { useSmartBackNavigation } from "./useSmartBackNavigation";

/**
 * Einheitlicher Zurück-Button der App-Leiste. Ziel und Label kommen nur aus useSmartBackNavigation:
 * gesetzte Herkunft oder übergeordnete Seite — nie ein hart verdrahteter Pfad ohne beides.
 */
export function LayoutBackButton() {
  const { text } = useI18n();
  const { backInfo, goBack } = useSmartBackNavigation();

  if (!backInfo) return null;

  return <SharedLayoutBackButton label={text(backInfo.labelKey)} onBack={goBack} />;
}
